import type { Atom } from 'jotai';
import { atom } from 'jotai';
import type { AtomOrValue } from './types/stage-atoms';
export function isAtom<T>(input: AtomOrValue<T>): input is Atom<T> {
  return input !== null && typeof input === 'object' && !Array.isArray(input) && 'read' in input;
}
export function resolveAtom<T>(input: AtomOrValue<T>): Atom<T> {
  return isAtom(input) ? input : atom(input);
}